export default __webpack_public_path__ + "static/cloud-bee-f3dd3aac31461d0765ca63f5bddea008.png";